var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSotDotsLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 511,
    viewBox: "0 0 241 511",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.5,
    cy: 34.527,
    rx: 34.5,
    ry: 34.527,
    fill: "#1BACE4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 193.2,
    cy: 151.919,
    rx: 27.6,
    ry: 27.6216,
    fill: "#EC1C24"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.8,
    cy: 89.7703,
    rx: 20.7,
    ry: 20.7162,
    fill: "#1BACE4"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.8,
    cy: 421.23,
    rx: 20.7,
    ry: 20.7162,
    fill: "#1BACE4"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.7,
    cy: 255.5,
    rx: 20.7,
    ry: 20.7162,
    fill: "#1BACE4"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 193.2,
    cy: 359.081,
    rx: 27.6,
    ry: 27.6216,
    fill: "#EC1C24"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.5,
    cy: 255.5,
    rx: 48.3,
    ry: 48.3378,
    fill: "#141414"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.1,
    cy: 255.5,
    rx: 27.6,
    ry: 27.6216,
    fill: "#EC1C24"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.5,
    cy: 476.473,
    rx: 34.5,
    ry: 34.527,
    fill: "#1BACE4"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.3,
    cy: 365.987,
    rx: 34.5,
    ry: 34.527,
    fill: "#1BACE4"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.3,
    cy: 145.014,
    rx: 34.5,
    ry: 34.527,
    fill: "#1BACE4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSotDotsLarge);
export default __webpack_public_path__ + "static/media/sotDotsLarge.20ec308b180192bbd340c0d085d6aa39.svg";
export { ForwardRef as ReactComponent };